// extracted by mini-css-extract-plugin
export var divider = "_ez-7";
export var itemsToggle = "_ez-8";
export var mergeModal = "_ez-1";
export var optionCard = "_ez-4";
export var radioGroup = "_ez-6";
export var radioOption = "_ez-0";
export var selected = "_ez-5";
export var shipmentOptions = "_ez-2";
export var tableOptions = "_ez-3";